import styled from 'styled-components';

export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    height: 80px;
    justify-content: center;
`;

export const Container = styled.div`
    height: 100%;
`;

export const Content = styled.div`
    height: calc(100% - 80px);
    overflow: auto;
`;

export const Message = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 16px;
    font-weight: normal;
    padding: 20px;
`;
